import React, { use, useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import axios from "axios";
import { Dialog } from "@headlessui/react";
import { Form, Spinner } from "react-bootstrap"
import API_BASE_URL from "../../config/api";

const LeaveDetailsModal = ({
  isOpen,
  onClose,
  leave,
  onRefresh,
  isRequester,
  isAdmin
}) => {
  const { token } = useContext(AuthContext);

  const [comment, setComment] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [notification, setNotification] = useState(null);

  const downloadFile = async (filePath) => {
    const response = await fetch(`${API_BASE_URL}/api/Employee/download/${filePath}`, {
      method: "GET",
      // headers: { Authorization: `Bearer ${token}` } // if needed
    });

    if (!response.ok) throw new Error("File not found or server error");

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = filePath.split("/").pop();
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const handleDecision = async (action) => {
    if (!comment.trim()) {
      setNotification({
        type: "error",
        message: "Cancellation or Approval or Rejection reason is required.",
      });
      return;
    }

    try {
      setIsLoading(true);
      await axios.put(
        `${API_BASE_URL}/api/RequestTimeOff/decide`,
        {
          id: leave.id,
          action: action,
          comment: comment,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setNotification({
        type: "success",
        message: `Leave ${action.toLowerCase()} successfully.`,
      });
      setComment("");
      if (onRefresh) onRefresh(); // Refresh parent list
      onClose();
    } catch (err) {
      console.error(err);
      setNotification({
        type: "error",
        message: "Failed to update leave status.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleCloseNotification = () => setNotification(null);

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40"
    >
      <Dialog.Panel className="bg-white rounded-2xl shadow-lg w-full max-w-xl p-6 space-y-6">
        <Dialog.Title className="text-2xl font-bold text-gray-800">
          Leave Request Details
        </Dialog.Title>

        {notification && (
          <div
            className={`mb-2 px-4 py-3 rounded flex justify-between items-start text-sm ${notification.type === "error"
                ? "bg-red-100 text-red-700"
                : "bg-green-100 text-green-700"
              }`}
          >
            <span>{notification.message}</span>
            <button
              onClick={handleCloseNotification}
              className="ml-4 font-bold text-lg leading-none"
            >
              ×
            </button>
          </div>
        )}

        <div className="grid grid-cols-2 gap-x-4 gap-y-3 text-sm text-gray-700">
          <div>
            <span className="font-semibold">Employee:</span>
            <br />
            {leave.employeeName}
            <br />
            ({leave.employeeId})
          </div>
          <div>
            <span className="font-semibold">Leave Type:</span>
            <br />
            {leave.leaveType}
          </div>
          <div>
            <span className="font-semibold">Start Date:</span>
            <br />
            {new Date(leave.startDate).toLocaleDateString()}
          </div>
          <div>
            <span className="font-semibold">End Date:</span>
            <br />
            {new Date(leave.endDate).toLocaleDateString()}
          </div>
          <div>
            <span className="font-semibold">Total Days:</span>
            <br />
            {leave.leaveDays}
          </div>
          <div>
            <span className="font-semibold">Status:</span>
            <br />
            {leave.status}
          </div>
          {leave.supportingDocument && leave.supportingDocument.trim() !== "" && (
            <div>
              <span className="font-semibold">Attachment:</span>
              <br />
              <a
                onClick={() => downloadFile(leave.supportingDocument)}
                download
                className="text-blue-600 hover:underline text-sm font-medium cursor-pointer"
              >
                Download
              </a>
            </div>
          )}
          <div className="col-span-2">
            <span className="font-semibold">Requested on:</span>
            <br />
            {new Date(leave.endDate).toLocaleDateString()}
          </div>
          <div className="col-span-2">
            <span className="font-semibold">Reason:</span>
            <br />
            {leave.reason}
          </div>
          {leave.statusId != "51" && (
            <div className="col-span-2">
              <span className="font-semibold">
                Approve / Rejection Comment:
              </span>
              <br />
              {leave.statusComment}
            </div>
          )}
        </div>
        {leave.statusId == "51" && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Comment
            </label>
            <textarea
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              className="w-full border border-gray-300 rounded-lg p-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              rows={3}
              placeholder="Write your cancellation or approval or rejection reason..."
            ></textarea>
          </div>
        )}
        <div className="flex justify-end gap-2">
          {leave.statusId == "51" &&
            isAdmin && !isRequester && (
              <div className="flex justify-end gap-2">
                <button
                  onClick={() => handleDecision("54")}
                  disabled={isLoading}
                  className="btn-danger"
                >
                  Reject
                </button>
                <button
                  onClick={() => handleDecision("53")}
                  disabled={isLoading}
                  className="btn-success"
                >
                  Approve
                </button>
              </div>
            )}
          {leave.status.toLowerCase() == "requested" && isRequester == true && (
            <div className="flex justify-end gap-2">
              <button
                onClick={() => handleDecision("52")}
                disabled={isLoading}
                className="btn-danger"
              >
                Cancel Request
              </button>
            </div>
          )}
          <button
            onClick={onClose}
            disabled={isLoading}
            className="cancel-btn"
          >
            Close
          </button>
        </div>
      </Dialog.Panel>
    </Dialog>
  );
};

export default LeaveDetailsModal;
